import MarketingChannelsFilter from "../../components/filters/MarketingChannelsFilter/MarketingChannelsFilter";
import MarketingChannelsFilterResult from "../../components/filters/MarketingChannelsFilter/MarketingChannelsFilterResult";
import MarketingChannelsFilterTag from "../../components/filters/MarketingChannelsFilter/MarketingChannelsFilterTag";
import { leadsFilterApiCategory } from "../../types/leadsFilterApiCategory";
import { leadsFilterCategoryMap } from "../../types/leadsFilterCategory";
import { defineDescriptionFilter } from "../defineSourcedFilter";

import FindMarketingChannelsFilter from "./MarketingChannelsFilter";

export const marketingChannelsDefinition = defineDescriptionFilter({
    key: "marketingChannels",
    apiCategory: leadsFilterApiCategory.marketingChannels,
    category: leadsFilterCategoryMap.trafficAndEngagement,
    trackingName: "Marketing Channels",
    titleKey: { key: "si.lead_gen_filters.marketing_channels.name" },

    render: ({ description }) => ({
        tooltipText: { key: "si.lead_gen_filters.group.marketing_channels.tooltip" },
        tag: MarketingChannelsFilterTag,
        filter: new FindMarketingChannelsFilter({
            options: description.bucketsDescription.marketingChannels,
        }),
        filterView: MarketingChannelsFilter,
        filterResultView: MarketingChannelsFilterResult,
    }),
});
